import React from 'react';
import { LuChevronRight } from 'react-icons/lu';

export default function FireSafetyAlertsDashboard() {
  // Data for Items Overdue Table
  const overdueItems = [
    { item: 'Fire Alarm Test', location: 'Kitchen', dueDate: '11 Jul 2026', overdueBy: '7 days' },
    { item: 'Portable Extinguisher', location: 'Bar Area', dueDate: '10 Jul 2026', overdueBy: '8 days' },
  ];

  // Data for Upcoming Action Due Table
  const upcomingActions = [
    { item: 'Fire Door Inspection', location: 'Dining Area', dueDate: '20 Jul 2026', daysRemaining: '2 days' },
    { item: 'Emergency Lighting Test', location: 'Office', dueDate: '22 Jul 2026', daysRemaining: '4 days' },
    { item: 'Extinguisher Inspection', location: 'Front of House', dueDate: '24 Jul 2026', daysRemaining: '6 days' },
  ];

  // Data for Fire Safety Certificates Table
  const certificates = [
    { name: 'Fire Risk Assessment', issued: '18 Mar 2026', expiry: '18 Mar 2027', status: 'Valid' },
    { name: 'Fire Alarm Certificate', issued: '15 Jan 2026', expiry: '15 Jan 2027', status: 'Valid' },
    { name: 'Emergency Lighting Certificate', issued: '10 Jan 2026', expiry: '10 Jan 2027', status: 'Valid' },
    { name: 'Fire Extinguisher Service Cert', issued: '12 Jul 2026', expiry: '12 Jul 2027', status: 'Valid' },
  ];

  return (
    <div className="w-full bg-slate-50 p-6 font-sans">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 max-w-[1800px] mx-auto items-stretch">
        
        {/* Card 1: Items Overdue */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[340px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Items Overdue
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[35%]">ITEM</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">DUE DATE</th>
                    <th className="p-2.5 text-right rounded-r-lg">OVERDUE BY</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {overdueItems.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.item}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-900 font-medium">{row.dueDate}</td>
                      <td className="p-2.5 text-right font-bold text-rose-600">{row.overdueBy}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all overdue items</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 2: Upcoming Action Due */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[340px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Upcoming Action Due
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[38%]">ITEM</th>
                    <th className="p-2.5">LOCATION</th>
                    <th className="p-2.5">DUE DATE</th>
                    <th className="p-2.5 text-right rounded-r-lg">DAYS REMAINING</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {upcomingActions.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.item}</td>
                      <td className="p-2.5 text-slate-600">{row.location}</td>
                      <td className="p-2.5 text-slate-900 font-medium">{row.dueDate}</td>
                      <td className="p-2.5 text-right font-bold text-orange-500">{row.daysRemaining}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all action due</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

        {/* Card 3: Fire Safety Certificates */}
        <div className="bg-white border border-slate-100 rounded-2xl p-5 shadow-sm min-h-[340px] flex flex-col justify-between">
          <div>
            <h2 className="text-[14px] font-bold text-indigo-950 mb-4">
              Fire Safety Certificates
            </h2>
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-indigo-50/40 text-[9px] font-bold text-indigo-950/70 tracking-wider">
                    <th className="p-2.5 rounded-l-lg w-[42%]">CERTIFICATE</th>
                    <th className="p-2.5">ISSUED</th>
                    <th className="p-2.5">EXPIRY DATE</th>
                    <th className="p-2.5 text-center rounded-r-lg">STATUS</th>
                  </tr>
                </thead>
                <tbody className="text-[11px] font-semibold text-slate-700 divide-y divide-slate-50">
                  {certificates.map((row, index) => (
                    <tr key={index} className="hover:bg-slate-50/40 transition-colors">
                      <td className="p-2.5 font-bold text-slate-800">{row.name}</td>
                      <td className="p-2.5 text-slate-500 font-medium">{row.issued}</td>
                      <td className="p-2.5 text-slate-900 font-medium">{row.expiry}</td>
                      <td className="p-2.5 text-center">
                        <span className="inline-block px-2 py-0.5 bg-emerald-50 text-emerald-600 text-[10px] font-extrabold border border-emerald-100 rounded-md tracking-wide">
                          {row.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <button className="mt-4 flex items-center justify-start gap-1 w-fit text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors py-1">
            <span>View all certificates</span>
            <LuChevronRight className="text-xs stroke-[2.5]" />
          </button>
        </div>

      </div>
    </div>
  );
}
